import { Slot } from '@radix-ui/react-slot';
import { cn } from '@utils/cn';
import { type ComponentProps } from 'react';

const TimeLineTitle = ({
  children,
  className,
  asChild = false,
  ...props
}: ComponentProps<'h1'> & { asChild?: boolean }) => {
  const Component = asChild ? Slot : 'h4';

  return (
    <Component
      className={cn('text-lg font-semibold text-card-foreground', className)}
      {...props}
    >
      {children}
    </Component>
  );
};

export { TimeLineTitle };
